module.exports = __webpack_public_path__ + "img/fourth.e030d339.png";